import React from 'react';
import { drapcodeIcon } from '../../common/custom/icon-library';
import EnvironmentSelect from '../../common/formElements/EnvironmentSelect';
import voca from 'voca';

export const ParentContentCardMultiHeader = ({
  children,
  title,
  icon,
  bgColor,
  isSearch,
  isEnvironment,
  updateSearchTerm,
  handleSearch,
  btnSize = 'sm',
  CtaComponent,
  refreshMethod,
  projectId,
  version,
  isEnvironmentInline,
  totalItems,
}) => {
  return (
    <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
      <div className="card">
        <div
          className="card-header card-header-icon"
          data-background-color={`${bgColor ? bgColor : 'drapcode-dark-blue'}`}
        >
          <i className={`wb ${drapcodeIcon(icon)}`}></i>
        </div>
        <div className="card-content">
          <div className="card-title-header">
            <h4 className="card-title">
              {voca.truncate(title, 40)}&nbsp;
              {totalItems > 0 ? (
                <span style={{ fontWeight: 'normal', textTransform: 'lowercase' }}>
                  {`(${totalItems || 0} records)`}
                </span>
              ) : (
                ''
              )}
            </h4>
            <div className="card-cta">{CtaComponent}</div>
            {isEnvironmentInline && (
              <div className="col-md-3">
                <EnvironmentSelect
                  projectId={projectId}
                  version={version}
                  refreshMethod={() => {
                    if (refreshMethod) {
                      refreshMethod();
                    }
                  }}
                />
              </div>
            )}
          </div>
          <div className={`${isEnvironment ? 'row' : ''}`}>
            <div className={`${isEnvironment ? 'col-md-8' : ''}`}>
              {isSearch && (
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    handleSearch();
                  }}
                  className={`${
                    isEnvironment ? '' : 'form-inline'
                  } mb-2 d-flex justify-content-between`}
                >
                  <input
                    type="text"
                    placeholder="Search..."
                    className="form-control col-11"
                    onChange={(e) => {
                      updateSearchTerm(e.target.value);
                    }}
                  />
                  <button
                    type="submit"
                    title={`Search ${title}`}
                    className={`btn btn-primary ${
                      btnSize === 'md' ? 'btn-md' : btnSize === 'lg' ? 'btn-lg' : 'btn-sm'
                    }`}
                  >
                    <i className="wb webconnect-search"></i>
                  </button>
                </form>
              )}
            </div>
            {isEnvironment && (
              <div className="col-md-4" style={{ zIndex: '1000' }}>
                <EnvironmentSelect
                  projectId={projectId}
                  version={version}
                  refreshMethod={() => {
                    if (refreshMethod) {
                      refreshMethod();
                    }
                  }}
                />
              </div>
            )}
          </div>
          {children}
        </div>
      </div>
    </div>
  );
};
